export default {"src":"/_next/static/media/clipboard-list.39966b23.svg","height":24,"width":24};